__turbopack_context__.v({
  "btn": "scrolltotop-module__bL7Q4W__btn",
  "show": "scrolltotop-module__bL7Q4W__show",
});
